// import {useEffect} from "react";
// import {callGetCategoriesAsync} from "../apis/categories";
import { categoriesStore } from "../stores/useCategoriesStore";
// import {callGetPostsAsync} from "../apis/posts";
import { postsStore } from "../stores/posts/postsStore";
// import {callGetPostCategoryAssociationsAsync} from "../apis/postCategoryAssociations";
import { postCategoryAssociationsStore } from "../stores/posts/usePostCategoryAssociationsStore";
// import {callGetPhotosAsync} from "../apis/photos";
import { photosStore } from "../stores/posts/usePhotosStore";
// import {alertService, createAsyncBuffer, RequestStatus} from "common-frontend-components";
import { globalAppConfigStore } from "../stores/appConfig/globalAppConfigStore";
import { productsStore } from "../stores/products/productsStore";
import { productCategoryAssociationsStore } from "../stores/products/productCategoryAssociationsStore";
import { productPhotosStore } from "../stores/products/productPhotosStore";
import { productIconsStore } from "../stores/products/productIconsStore";
import { productPostAssociationsStore } from "../stores/products/productPostAssociationsStore";
// import {callGetProductsAsync} from "../apis/products";
// import {callGetProductCategoryAssociationsAsync} from "../apis/productCategoryAssociations";
// import {callGetProductPhotosAsync} from "../apis/productPhotos";
// import {callGetProductIconsAsync} from "../apis/productIcons";
// import {callGetProductPostAssociationsAsync} from "../apis/productPostAssociations";
import { galleriesStore } from "../stores/galleries/galleriesStore";
import { galleryCategoryAssociationsStore } from "../stores/galleries/galleryCategoryAssociationsStore";
import { galleryPhotosStore } from "../stores/galleries/galleryPhotosStore";
import { galleryIconsStore } from "../stores/galleries/galleryIconsStore";
// import {callGetGalleriesAsync} from "../apis/galleries";
// import {callGetGalleryCategoryAssociationsAsync} from "../apis/galleryCategoryAssociations";
// import {callGetGalleryPhotosAsync} from "../apis/galleryPhotos";
// import {callGetGalleryIconsAsync} from "../apis/galleryIcons";
//
// const asyncBuffer = createAsyncBuffer();
//
// const loadRequests = (getRequestPromises:()=>Promise<any|void>[]) => async () => {
//   try {
//     await Promise.all(getRequestPromises())
//     // tslint:disable-next-line:no-empty
//   } catch (e) {}
// }
export const useOnLazyPageLoad = () => {
    // galleries
    galleriesStore.useLoad();
    galleryCategoryAssociationsStore.useLoad();
    galleryPhotosStore.useLoad();
    galleryIconsStore.useLoad();
    // categories
    categoriesStore.useLoad();
    // posts
    postsStore.useLoad();
    postCategoryAssociationsStore.useLoad();
    photosStore.useLoad();
    // products
    productsStore.useLoad();
    productCategoryAssociationsStore.useLoad();
    productPhotosStore.useLoad();
    productIconsStore.useLoad();
    productPostAssociationsStore.useLoad();
};
export const useOnAppLoad = () => {
    globalAppConfigStore.useLoad();
    // const globalAppConfigLoaded = globalAppConfigStore.useStatus()===RequestStatus.loaded;
    // useEffect(() => {
    //   if (globalAppConfigLoaded)
    //     return;
    //
    //   // galleries
    //   galleriesStore.setRequestStatus(RequestStatus.loading);
    //   galleryCategoryAssociationsStore.setRequestStatus(RequestStatus.loading);
    //   galleryPhotosStore.setRequestStatus(RequestStatus.loading);
    //   galleryIconsStore.setRequestStatus(RequestStatus.loading);
    //
    //   // categories
    //   categoriesStore.setRequestStatus(RequestStatus.loading);
    //
    //   // posts
    //   postsStore.setRequestStatus(RequestStatus.loading);
    //   postCategoryAssociationsStore.setRequestStatus(RequestStatus.loading);
    //   photosStore.setRequestStatus(RequestStatus.loading);
    //
    //   // products
    //   productsStore.setRequestStatus(RequestStatus.loading);
    //   productCategoryAssociationsStore.setRequestStatus(RequestStatus.loading);
    //   productPhotosStore.setRequestStatus(RequestStatus.loading);
    //   productIconsStore.setRequestStatus(RequestStatus.loading);
    //   productPostAssociationsStore.setRequestStatus(RequestStatus.loading);
    //
    //   asyncBuffer(loadRequests( ()=>[
    //     // galleries
    //     callGetGalleriesAsync()
    //       .then((items) => {
    //         galleriesStore.setGalleries(items);
    //         galleriesStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         galleriesStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetGalleryCategoryAssociationsAsync()
    //       .then((items) => {
    //         galleryCategoryAssociationsStore.setGalleryCategoryAssociations(items);
    //         galleryCategoryAssociationsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         galleryCategoryAssociationsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetGalleryPhotosAsync()
    //       .then((items) => {
    //         galleryPhotosStore.setPhotosRaw(items);
    //         galleryPhotosStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         galleryPhotosStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetGalleryIconsAsync()
    //       .then((items) => {
    //         galleryIconsStore.setIconsRaw(items);
    //         galleryIconsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         galleryIconsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //   ]));
    //
    //   asyncBuffer( ()=>
    //     callGetPhotosAsync()
    //       .then((items) => {
    //         photosStore.setPhotosRaw(items);
    //         photosStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         photosStore.setRequestStatus(RequestStatus.failed);
    //       }));
    //
    //   asyncBuffer(loadRequests( ()=>[
    //     // categories
    //     callGetCategoriesAsync()
    //       .then((items) => {
    //         categoriesStore.setCategories(items);
    //         categoriesStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         categoriesStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     // posts
    //     callGetPostsAsync()
    //       .then((items) => {
    //         postsStore.setPosts(items);
    //         postsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         postsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetPostCategoryAssociationsAsync()
    //       .then((items) => {
    //         postCategoryAssociationsStore.setPostCategoryAssociations(items);
    //         postCategoryAssociationsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         postCategoryAssociationsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //   ]));
    //
    //   asyncBuffer(loadRequests( ()=>[
    //     callGetPhotosAsync()
    //       .then((items) => {
    //         photosStore.setPhotosRaw(items);
    //         photosStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         photosStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     // products
    //     callGetProductsAsync()
    //       .then((items) => {
    //         productsStore.setProducts(items);
    //         productsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         productsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetProductCategoryAssociationsAsync()
    //       .then((items) => {
    //         productCategoryAssociationsStore.setProductCategoryAssociations(items);
    //         productCategoryAssociationsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         productCategoryAssociationsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetProductPhotosAsync()
    //       .then((items) => {
    //         productPhotosStore.setPhotosRaw(items);
    //         productPhotosStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         productPhotosStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetProductIconsAsync()
    //       .then((items) => {
    //         productIconsStore.setIconsRaw(items);
    //         productIconsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         productIconsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //
    //     callGetProductPostAssociationsAsync()
    //       .then((items) => {
    //         productPostAssociationsStore.setProductPostAssociations(items);
    //         productPostAssociationsStore.setRequestStatus(RequestStatus.loaded);
    //       })
    //       .catch((e) => {
    //         alertService.error(e);
    //         productPostAssociationsStore.setRequestStatus(RequestStatus.failed);
    //       }),
    //   ]));
    // }, [globalAppConfigLoaded]);
};
//# sourceMappingURL=useOnAppLoad.js.map